import { faqs } from '@/mocks/home';

export default function FAQ() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">吃瓜须知</h2>
          <p className="text-sm text-foreground-600">关于51吃瓜，你想知道的都在这里</p>
        </div>
        <div className="space-y-3">
          {faqs.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl p-5">
              <h3 className="font-heading text-base text-foreground-900 mb-2">{item.question}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}